import './App.css';
import { QRCodeSVG } from 'qrcode.react';
import { FC, useState } from 'react';
import { toJpeg } from 'html-to-image';

// Create a titleview for the app
const TitleView = () => {
  return (
    <div className="title">
      <h1>Card Editor</h1>
      <p>Flexable kanban card creator</p>
    </div>
  )
}

// Interface for the qr code
interface QRCodeProps {
  url: string
}

// View for the qr code
const QRCode: FC<QRCodeProps> = (props: QRCodeProps): JSX.Element => {
  return <>
    <QRCodeSVG value={props.url} size={300} />
  </>;
}

// View to add multiple cards
const CardEditorCanvas = () => {
  const [cards, setCards] = useState([{id: "abcd"}])

  return (
    <div>
      <div className="card_editor_canvas">
        {
          cards.map((card) => {
            return (
              <div key={card.id}>
                <CardEditor />
                <RemoveButton onClick={() => { setCards(cards.filter(item => item.id !== card.id)) }} />
              </div>
            )
          })
        }
      </div>
      <button onClick={() => {
        setCards([...cards, {id: Math.random().toString(36).slice(-6)}])
      }}>Add Card</button>
      <button onClick={downloadQRCodeReact}>Download</button>
    </div>
  )
}

// interface for the close button that accepts a function to remove the card
interface RemoveButtonProps {
  onClick: () => void
}

// small close button for the card
const RemoveButton = (props: RemoveButtonProps) => {
  return (
    <div className="card_close_button hide_on_generate" onClick={props.onClick} >
      <p>remove</p>
    </div>
  )
}

// Interface for the card
interface CardEditorProps {
}

// Create preview for the card
const CardEditor: FC<CardEditorProps> = (props: CardEditorProps) => {
  const [link, setLink] = useState('')
  const [title, setTitle] = useState('')
  const [subtitle, setSubtitle] = useState('')
  const [description, setDescription] = useState('')

  return (
    <div className="card">
      <div className="card__qrcode" >
        <QRCode url={link} />
      </div>
      <div className="card__details">
        <div className="card__details__title">
          <input type="text" name="title" value={title} className="input_title" placeholder="45mm 8g screws" onChange={e => setTitle(e.target.value)} />
          <input type="text" name="subtitle" value={subtitle} className="input_subtitle" placeholder="Bunnings" onChange={e => setSubtitle(e.target.value)} />
        </div>
        <div className="card__details__divider"></div>
        <div className="card__details__description">
          <textarea name="description" value={description} className="input_description" cols={5} wrap="hard" placeholder="Description..." onChange={e => setDescription(e.target.value)} />
        </div>
        <div className="card__details__divider"></div>
        <div className="card__details__meta">
          <p>created: {new Date().toLocaleDateString()}</p>
          <input type="text" name="link" className="input_link" value={link} placeholder="things:///add?title=45mm&when=today" onChange={e => setLink(e.target.value)} />
        </div>
      </div>
    </div>
  )
}

const FaqView = () => { 
  return (
    <div className="faq">
      <h2>FAQ</h2>
      <h4>What is this?</h4>
      <p>This is a tool to create card that you print and place next to your supplies. When you run low on supplies you scan the qr code which will add a new item in your todo list so that you can remember to purchase it.</p>
      <h4>Can I use any url?</h4>
      <p>Yes.</p>
      <h4>What is the things3 url generator link?</h4>
      <a href="https://culturedcode.com/things/support/articles/2803573/#link-builder" target="_blank" rel="noreferrer">Things 3 Documentation</a>
    </div>
  )
}

const App = () => {

  return (
    <div className="app">
      <TitleView />
      <CardEditorCanvas />
      <FaqView />
    </div>
  );
}

// function to download react view as jpeg using html-to-image
const downloadQRCodeReact = () => {
  toggleElementOpacity(true);
  const node = document.querySelector('.card_editor_canvas') as HTMLElement;
  toJpeg(node, { quality: 1.0 })
    .then((dataUrl) => {
      let downloadLink = document.createElement('a');
      var img = new Image();
      img.src = dataUrl;
      downloadLink.href = img.src;
      downloadLink.download = 'qrcode.jpeg';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      toggleElementOpacity(false);
    });
}

const toggleElementOpacity = (hide: boolean) => {
  const elements = document.querySelectorAll('.hide_on_generate') as NodeListOf<HTMLElement>;
  elements.forEach((element) => {
    element.style.opacity = hide ? "0" : "1";
  })
}


export default App;
